import Icon, {iconColor, iconTypes} from "../../../common/components/Icon.jsx";

import DeliveringDate from "../deliveringDate.jsx";
import DeliveringStatus from "../deliveringStatus";
import {Localization} from "../../../common/util/localization.jsx";
import ProductsDisplay  from "./productDisplay.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn.jsx";
import ResponsiveRows from "../../../common/components/ResponsiveRows.jsx";
import { getProgressForOrderDate } from "../../util/orderUtil.js";
import { getTimeLeftSeconds } from "../../../common/util/time.js";
import moment from "moment";
import { withRouter } from "react-router-dom";

class NextDeliveryCard extends React.PureComponent {
    constructor(props){
        super(props);
        
        this.state = {
            minute: -1
        };

        this.onClickAddProducts = this.onClickAddProducts.bind(this);

        this.checkTime = this.checkTime.bind(this);
    }
    componentDidMount() {
        this.interval = setInterval(this.checkTime, 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    onClickAddProducts() {
        if(this.props.deviceType === "xs")
            this.props.history.push("/order/products/all");
        else this.props.history.push("/order/products/");
    }
    checkTime() {
        const date = new Date;
        const minute = date.getMinutes();
        if( this.state.minute!=minute){
            this.setState({minute:minute});
        }
    }
    render(){
        const {
            localization,
            nextDelivery,
            submitOrder,
            isBlockedCustomer,
        } = this.props;
        let deliveredDate = "";
        let deliveredTime = "";
        if( nextDelivery ) {
            deliveredDate = nextDelivery.deliveryDate ? moment(nextDelivery.deliveryDate).format("MMMM DD") : "";
            deliveredTime = nextDelivery.deliveryDate ? moment(nextDelivery.deliveryDate).format(`[${localization.text("time","at")}] HH:mm`) : "";
        }

        const progress = getProgressForOrderDate(nextDelivery.customerDeadlineDate);
        const sLeft = getTimeLeftSeconds(nextDelivery.customerDeadlineDate);
        const canSendInOrder = !nextDelivery.loading && (nextDelivery.unConfirmedOrderLines && nextDelivery.unConfirmedOrderLines.length || 0)>0 && sLeft>0;
        const nextDeliveryProductList = (nextDelivery.unConfirmedOrderLines || []).concat(nextDelivery.orderLines || []);
        const totalOrderLines = (nextDelivery==null || nextDelivery.orderLines==null)?0:nextDelivery.orderLines.length;

        return (
            <div className="card-default">
                <div style={{display:"flex"}} >
                    <div className="dashboard-card-left">
                        <label className="dashboard-card-header">
                            {localization.text("dashboard","nextDelivery")}
                        </label>
                        <div style={{paddingTop:"16px"}}>
                            <DeliveringStatus localization={localization} isDelivered={false} deadlineDate={nextDelivery.customerDeadlineDate} progress={progress} />
                        </div>
                        <div style={{paddingTop:"16px"}}>
                            <DeliveringDate localization={localization} deliveryDate={deliveredDate} deliveryTime={deliveredTime} deliveryStatus={0} delivery={nextDelivery} />
                        </div>
                        {totalOrderLines>0 && (
                            <div className="order-lines">
                                <div className="text-bottom">
                                    {localization.text("dashboard","xOrderLines",{count:totalOrderLines})}
                                </div>
                            </div>
                        )}
                    </div>
                    <ProductsDisplay localization={localization} useText={["dashboard","xLinesAdded"]} products={nextDeliveryProductList || []} count={nextDelivery.unConfirmedOrderLines?nextDelivery.unConfirmedOrderLines.length:0}/>
                </div>
                <div className="hr"/>
                <div className="dashboard-card-bottom">
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn xs={12} lg={6}>
                            <button className={"btn icon block"} onClick={this.onClickAddProducts}  disabled={isBlockedCustomer}>
                                <Icon type={iconTypes.plus} color={iconColor.red}/>
                                {localization.text("dashboard","addProducts")}
                            </button>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={12} lg={6}>
                            <button className={"btn primary block"} onClick={submitOrder}  disabled={!canSendInOrder || isBlockedCustomer}>
                                {localization.text("dashboard","submitOrder")}
                            </button>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            </div>
        );
    }
}
NextDeliveryCard.propTypes = {
    localization: Localization.propTypes.isRequired,
    history: PropTypes.object.isRequired,
    submitOrder: PropTypes.func.isRequired,
    nextDelivery: PropTypes.object,
    isBlockedCustomer: PropTypes.bool.isRequired,
    deviceType: PropTypes.string.isRequired,
};

export default withRouter(NextDeliveryCard);